/** External SMS marketing provider a merchant has connected for Recover. */
export enum ExternalSmsMarketingProvider {
  ATTENTIVE = "attentive",
  KLAVIYO = "klaviyo",
  POSTSCRIPT = "postscript",
  SHOPIFY = "shopify",
}
